import {checkLoadButton} from './checkLoadButton';
import {fixChooserForm} from './fixChooserForm';
import {initLazyImages} from '../../elements/img.lazy-image';
import {initVisualChooser} from './initVisualChooser';
import {iterateCheckboxes} from './iterateCheckboxes';
import {iterateCheckboxesLists} from './iterateCheckboxesLists';
import {iterateRanges} from './iterateRanges';
import {parseSearchString} from '../../../utils/convertation/parseSearchString';
import PerfectScrollbar from 'perfect-scrollbar';
import {pluralNumber} from '../../../utils/numerals/pluralNumber';
import {renderComplexesLists} from './renderComplexesLists';
import {requestData} from './requestData';
import {stringifySearchParameters} from '../../../utils/convertation/stringifySearchParameters';
import {updateCriteo} from '../../common/criteo';
import {updateMargin} from './updateMargin';
import {initStickers} from "./stickers";
import {updateRange} from '../../elements/div.range';

export const initChooser = () => {
	const chooser = document.querySelector( 'form.chooser-form' );

	if ( !chooser )
	{
		initVisualChooser();
		return;
	}

	const componentId = chooser.dataset.id;
	const quick = chooser.parentNode.classList.contains( 'chooser-quicksearch' );
	const searchParameters = parseSearchString( location.search );

	Object.keys( searchParameters ).forEach( ( it ) => {
		if ( it !== 'utm_source' && it !== 'utm_medium' && it !== 'utm_campaign' && it !== 'utm_term' && it !== 'utm_content' && it !== 'calltouch_tm' )
		{
			delete searchParameters[it];
		}
	} );

	const utmParameters = stringifySearchParameters( searchParameters ).replace( '\?', '&' );
	
	const query = {
		search: '',
		userChanged: '',
		latestChanged: ''
	};

	let heading, complexesLists;

	if ( !quick )
	{
		heading = chooser.parentNode.querySelector( 'p[data-count]' );
		complexesLists = chooser.parentNode.querySelectorAll( 'ul.apartments' );
		updateMargin();
	}

	let ps = null;

	const togglePerfectScrollbar = () => {
		if ( window.innerWidth < 956 && ps )
		{
			ps.destroy();
			ps = null;
		}
	
		if ( window.innerWidth >= 956 && !ps )
		{
			ps = new PerfectScrollbar( chooser, {
				wheelPropagation: false,
			} );
		}

		if ( ps )
		{
			ps.update();
		}
	};

	const processInputsState = ( evt ) => {
		const action = location.pathname;

		if ( evt )
		{
			if ( evt.target.closest( 'div.range' ) )
			{
				evt.target.classList.add( 'user-changed' );

				if (
						evt.target.classList.contains( 'user-min' ) && parseFloat( evt.target.closest( 'div.range' ).dataset.min ) === parseFloat( evt.target.value.replace( / /g, '' ) )
					||	evt.target.classList.contains( 'user-max' ) && parseFloat( evt.target.closest( 'div.range' ).dataset.max ) === parseFloat( evt.target.value.replace( / /g, '' ) )
				)
				{
					evt.target.classList.remove( 'user-changed' );
				}
			}
			else
			{
				evt.target.classList.toggle( 'user-changed' );
			}

			query.latestChanged = evt.target.closest( 'li[data-for]' ).dataset.for;
		}

		chooser.classList.add( 'disabled' );
		query.search = '';
		query.userChanged = '';
		iterateCheckboxes( chooser, query );
		iterateCheckboxesLists(chooser, query );
		iterateRanges( chooser, query );

		if ( query.search !== '' )
		{
			query.search = '&' + query.search;
			chooser.classList.remove( 'empty' );
		}
		else
		{
			chooser.classList.add( 'empty' );
		}

		let url = action + '?type=param' + query.search;
		
		if ( !quick )
		{
			window.history.pushState( {}, document.querySelector( 'head title' ).innerHTML, url + utmParameters );
		}
		
		url += '&ajax_component=' + componentId
			
		if ( chooser.querySelector( 'input[name="sort"]:checked' ) )
		{
			url += '&sort=' + chooser.querySelector( 'input[name="sort"]:checked' ).value;
		}

		requestData( url, ( msg ) => {
			const chooserData = msg.components[componentId];

			Array.from( chooser.querySelectorAll( 'li.disabled' ) ).forEach( ( it ) => {
				it.classList.remove( 'disabled' );
			} );

			if ( chooserData.controls )
			{
				for ( const control in chooserData.controls )
				{
					const formItem = chooser.querySelector( `li[data-for="${control}"]` );

					if ( formItem )
					{
						if ( formItem.classList.contains( 'range' ) )
						{
							const minInput = formItem.querySelector( 'input.user-min' );
							const maxInput = formItem.querySelector( 'input.user-max' );
							
							if ( chooserData.controls[control].listening_min )
							{
								minInput.value = chooserData.controls[control].listening_min;
							}
							
							if ( chooserData.controls[control].listening_max )
							{
								maxInput.value = chooserData.controls[control].listening_max;
							}

							updateRange( minInput.closest( 'div.range' ) );
						}
						else if ( formItem.classList.contains( 'checkbox' ) )
						{
							if ( !chooserData.controls[control].listening )
							{
								formItem.classList.add( 'disabled' );
							}
							else
							{
								formItem.classList.remove( 'disabled' );
							}
						}
						else if ( formItem.classList.contains( 'checkboxes' ) )
						{
							const latestChanged = new RegExp( ','+ control );

							if ( !latestChanged.test( query.userChanged ) )
							{
								Array.from( formItem.querySelectorAll( 'input:not(.multiselect)' ) ).forEach( ( it ) => {
									const value = it.dataset.building ? it.dataset.building : it.value;
									
									if ( chooserData.controls[control].listening && chooserData.controls[control].listening.indexOf( value ) === -1 )
									{
										it.closest( 'li' ).classList.add( 'disabled' );
									}
								} );
							}
						}
					}
				}
			}
			else if ( !quick )
			{
				Array.from( chooser.querySelectorAll( 'div.range' ) ).forEach( ( it ) => {
					updateRange( it, true );
				} );
			}

			if ( quick )
			{
				chooser.querySelector( 'button[type="submit"]' ).innerHTML = chooserData.rooms_total > 0 ? `Показать ${chooserData.rooms_total}&nbsp;${pluralNumber( chooserData.rooms_total, 'квартиру', 'квартиры', 'квартир' )}` : `Ни одной квартиры`;
				chooser.querySelector( 'button[type="submit"]' ).disabled = chooserData.rooms_total === 0;
			}
			else
			{
				let complexesCount = 0;

				if ( chooserData.split_into_complexes )
				{
					Object.values( chooserData.complexes ).forEach( ( it ) => {
						if ( it.rooms_total )
						{
							complexesCount++;
						} 
					} );
				}
				
				heading.dataset.count = chooserData.rooms_total;
				heading.innerHTML = `${pluralNumber( chooserData.rooms_total, 'Найден', 'Найдено', 'Найдено' )} ${chooserData.rooms_total}&nbsp;${pluralNumber( chooserData.rooms_total, 'вариант', 'варианта', 'вариантов' )}${complexesCount ? ` в&nbsp;${complexesCount}&nbsp;${pluralNumber( complexesCount, 'комплексе', 'комплексах', 'комплексах' )}` : ''}`;
				renderComplexesLists( complexesLists, chooserData, true, true );
			}

			fixChooserForm( chooser );
			chooser.classList.remove( 'disabled' );
			updateCriteo();
		}, query.userChanged );
	};

	Array.from( chooser.querySelectorAll( 'input[name*="["]' ) ).forEach( ( input ) => {
		input.addEventListener( 'change', processInputsState );
	} );

	chooser.addEventListener( 'submit', ( evt ) => {
		if ( !quick )
		{
			return;
		}

		evt.preventDefault();

		let url = chooser.action + '?type=param' + query.search;

		location.href = url;
	} );

	processInputsState();

	if ( quick )
	{
		return;
	}

	Array.from( chooser.querySelectorAll( 'input[name="sort"]' ) ).forEach( ( input ) => {
		input.addEventListener( 'change', ( evt ) => {
			const select = document.querySelector( 'div.select.sort' );
			let url = location.pathname + location.search;

			chooser.classList.add( 'disabled' );
			url += location.search ? '&' : '?';
			url += 'sort=' + evt.target.value;
			url += '&ajax_component=' + componentId;
			select.querySelector( 'label.selected' ).classList.remove( 'selected' );
			select.querySelector( `label[for="${evt.target.value}"]` ).classList.add( 'selected' );
			select.querySelector( `span.value` ).innerHTML = select.querySelector( `label[for="${evt.target.value}"]` ).innerHTML;
			select.children[0].checked = false;

			requestData( url, ( msg ) => {
				const chooserData = msg.components[componentId];

				renderComplexesLists( complexesLists, chooserData, true, true );
				chooser.classList.remove( 'disabled' );
			}, query.userChanged );
		} );
	} );

	Array.from( complexesLists ).forEach( ( list ) => {
		list.querySelector( 'button.load-more' ).addEventListener( 'click', ( evt ) => {
			evt.preventDefault();

			let url = location.pathname + location.search;

			list.classList.add( 'disabled' );
			url += location.search ? '&' : '?';
			url += 'page=' + evt.target.dataset.nextPage;

			if ( evt.target.dataset.complex )
			{
				url += '&complex=' + evt.target.dataset.complex;
			}

			url += '&ajax_component=' + componentId;
			
			if ( chooser.querySelector( 'input[name="sort"]:checked' ) )
			{
				url += '&sort=' + chooser.querySelector( 'input[name="sort"]:checked' ).value;
			}

			evt.target.dataset.nextPage = +evt.target.dataset.nextPage + 1;

			requestData( url, ( msg ) => {
				const complexId = evt.target.dataset.complex ? evt.target.dataset.complex : Object.keys( msg.components[componentId].complexes )[0];
				const chooserData = msg.components[componentId];
				const roomsLeft = chooserData.rooms_left ? chooserData.rooms_left : chooserData.complexes[complexId].rooms_left;

				list.classList.add( 'with-lazy-images' );
				list.querySelector( 'li.more' ).insertAdjacentHTML( 'beforebegin', chooserData.complexes[complexId].rendered );
				initLazyImages();
				checkLoadButton( evt.target, roomsLeft, chooserData.next_page );
				list.classList.remove( 'disabled' );
				updateCriteo();
			}, query.userChanged );
		} );
	} );

	const resetButton = chooser.querySelector( 'button[type="reset"]' );

	if ( !resetButton )
	{
		return;
	}

	const resetButtonEmpty = document.querySelector( 'div.empty button.reset' );

	const resetForm = ( evt ) => {
		evt.preventDefault();

		const url = location.pathname + '?type=param';

		chooser.classList.add( 'disabled' );
		chooser.classList.add( 'empty' );
		window.history.pushState( {}, document.querySelector( 'head title' ).innerHTML, url + utmParameters );

		Array.from( chooser.querySelectorAll( 'li.disabled' ) ).forEach( ( it ) => {
			it.classList.remove( 'disabled' );
		} );
		
		Array.from( chooser.querySelectorAll( 'input:checked' ) ).forEach( ( input ) => {
			input.checked = false;
		} );

		Array.from( chooser.querySelectorAll( 'input.user-changed' ) ).forEach( ( input ) => {
			input.classList.remove( 'user-changed' );
		} );

		Array.from( chooser.querySelectorAll( 'label.multiselect span' ) ).forEach( ( span ) => {
			span.innerHTML = '';
		} );

		requestData( url, ( msg ) => {
			const chooserData = msg.components[componentId];
			let complexesCount = 0;

			if ( chooserData.split_into_complexes )
			{
				Object.values( chooserData.complexes ).forEach( ( it ) => {
					if ( it.rooms_total )
					{
						complexesCount++;
					} 
				} );
			}
			
			heading.dataset.count = chooserData.rooms_total;
			heading.innerHTML = `${pluralNumber( chooserData.rooms_total, 'Найден', 'Найдено', 'Найдено' )} ${chooserData.rooms_total}&nbsp;${pluralNumber( chooserData.rooms_total, 'вариант', 'варианта', 'вариантов' )}${complexesCount ? ` в&nbsp;${complexesCount}&nbsp;${pluralNumber( complexesCount, 'комплексе', 'комплексах', 'комплексах' )}` : ''}`;
			renderComplexesLists( complexesLists, chooserData, true );
			chooser.classList.remove( 'disabled' );
			updateCriteo();
		}, query.userChanged );
	};

	const setChooserWidth = () => {
		chooser.style.width = '';
		chooser.style.width = window.getComputedStyle( chooser ).width;
	};

	resetButton.addEventListener( 'click', resetForm );
	resetButtonEmpty.addEventListener( 'click', resetForm );
	window.addEventListener( 'resize', togglePerfectScrollbar );
	togglePerfectScrollbar();
	setChooserWidth();
	window.addEventListener( 'resize', setChooserWidth );

	window.addEventListener( 'scroll', () => {
		fixChooserForm( chooser );
	} );
	
	initStickers( chooser.closest( 'section.chooser' ) );
};
